/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IIdentityResponse } from '../models/IIdentityResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class IdentityService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns IIdentityResponse
     * @throws ApiError
     */
    public getIdentityGetIdentity(): CancelablePromise<IIdentityResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/identity',
        });
    }

}
